import localhost from "apis/localhost";
import { MULTIPART_FORM_DATA_CONTENT_TYPE } from "constants/app";
import { showErrorModal } from "slices/app/actions/error";
import { pageLoading } from "slices/app/appSlice";

export const createFolder =
  (handleSuccess, handleFailure, folderName, parentFolderId) =>
  async (dispatch) => {
    dispatch(pageLoading(true));
    await localhost
      .post(
        "/folders/create",
        {
          folderName,
          parentFolderId,
        },
        {
          headers: {
            "Content-Type": MULTIPART_FORM_DATA_CONTENT_TYPE,
          },
        }
      )
      .then(async (res) => {
        handleSuccess(res.data, folderName);
      })
      .catch((error) => {
        handleFailure(error);
      })
      .finally(() => {
        dispatch(pageLoading(false));
      });
  };

export const getFolders =
  (handleSuccess, handleFailure) => async (dispatch) => {
    dispatch(pageLoading(true));
    await localhost
      .get("/folders/list")
      .then(async (res) => {
        handleSuccess(res.data);
      })
      .catch((error) => {
        handleFailure(error);
      })
      .finally(() => {
        dispatch(pageLoading(false));
      });
  };

export const recheckReadability =
  (handleSuccess, folderId) => async (dispatch) => {
    dispatch(pageLoading(true));
    return localhost
      .post(`/folders/${folderId}/recheck-readability`, {})
      .then(() => {
        handleSuccess();
      })
      .catch((error) => {
        dispatch(showErrorModal(error));
      })
      .finally(() => {
        dispatch(pageLoading(false));
      });
  };
